import { CoreModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, effect, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CustomerQuoteService,
  CustomerQuoteVersionLookupDto,
} from '@digiwall/goliath-documents/proxy';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'document-quote-version-select',
  templateUrl: './quote-version-select.component.html',
  styleUrl: './quote-version-select.component.scss',
  imports: [CommonModule, NgSelectModule, CoreModule, FormsModule, AutoSizedDropdownDirective],
})
export class QuoteVersionSelectComponent {
  public docId = input<string>();

  public versionLoaded = output<CustomerQuoteVersionLookupDto[]>();

  protected versions = signal<CustomerQuoteVersionLookupDto[]>([]);

  constructor(
    quoteService: CustomerQuoteService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    effect(() => {
      quoteService.getVersions(this.docId()).subscribe(response => {
        this.versions.set(response);
        this.versionLoaded.emit(response);
      });
    });
  }

  protected versionChanged(docVersion: CustomerQuoteVersionLookupDto) {
    if (docVersion == null) {
      return;
    }
    this.router.navigate(['..', docVersion.docId], { relativeTo: this.route });
  }
}
